import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { PatentDescService } from '@telecom/shared/services/patent/patent-desc-service';
import { PatentImageService } from '@telecom/shared/services/patent/patent-image-service';
import { PatentDescServiceImpl } from '@telecom/shared/services/patent/impls/patent-desc-service-impls';
import { PatentImageServiceImpl } from '@telecom/shared/services/patent/impls/patent-image-service-impls';
import { PatentDescApi } from '@telecom/shared/infrastructure/api-functions/patent-desc-api';
import { PatentApiImpl } from '@telecom/shared/infrastructure/api-functions/impls/patent-api-impl';
import { PatentImageApi } from '@telecom/shared/infrastructure/api-functions/patent-image-api';
import { PublicShareApi } from '@telecom/shared/infrastructure/api-functions/public-share-api';
import { PublicShareApiImpl } from '@telecom/shared/infrastructure/api-functions/impls/public-share-api-impl';
import { PatentDbService } from '@telecom/shared/services/patent/patent-db-service';
import { PatentDbServiceImpl } from '@telecom/shared/services/patent/impls/patent-db-service-impl';
import { PatentDbApi } from '@telecom/shared/infrastructure/api-functions/patent-db-api';
import { PatentClaimApi } from '@telecom/shared/infrastructure/api-functions/patent-claim-api';
import { PatentClaimService } from '@telecom/shared/services/patent/patent-claim-service';
import { PatentClaimServiceImpl } from '@telecom/shared/services/patent/impls/patent-claim-service-impl';
import { PatentLegalStatusApi } from '@telecom/shared/infrastructure/api-functions/patent-legal-status-api';
import { PatentLegalStatusService } from '@telecom/shared/services/patent/patent-legal-status-service';
import { PatentLegalStatusServiceImpl } from '@telecom/shared/services/patent/impls/patent-legal-status-service-impl';
import { companyModule } from '@telecom/shared/domain/company';
import { patentModule } from '@telecom/shared/domain/patent';
import { abModule } from '@telecom/shared/domain/ab';
import { permissionV2Module } from '@telecom/shared/domain/permission';
import { documentParseModule } from '@telecom/shared/domain/document-parse';
import { imageUploadModule } from '@telecom/shared/domain/image-upload';
import { generalFileUploadModule } from '@telecom/shared/domain/file-upload';
import { userSettingsModule } from '@telecom/shared/domain/user-settings';
import { CreatePublicShareLinkApi } from '@telecom/shared/infrastructure/api-functions/create-public-share-link-api';

export const sharedModule = new ContainerModule((bind) => {
    // #region 分享相关
    bind(PublicShareApiImpl).toSelf();
    bind(PublicShareApi).toService(PublicShareApiImpl);
    bind(CreatePublicShareLinkApi).toService(PublicShareApiImpl);
    // #endregion
    // #region 专利相关
    bind(PatentDescApi).to(PatentApiImpl);
    bind(PatentDescService).to(PatentDescServiceImpl);
    bind(PatentClaimApi).to(PatentApiImpl);
    bind(PatentClaimService).to(PatentClaimServiceImpl);
    bind(PatentLegalStatusApi).to(PatentApiImpl);
    bind(PatentLegalStatusService).to(PatentLegalStatusServiceImpl);
    // #endregion
    // #region 专利图片相关
    bind(PatentImageApi).to(PatentApiImpl);
    bind(PatentImageService).to(PatentImageServiceImpl);
    // #endregion
    // #region 专利数据库相关
    bind(PatentDbApi).to(PatentApiImpl);
    bind(PatentDbService).to(PatentDbServiceImpl);
    // #endregion
});
export const sharedModules = [sharedModule, companyModule, patentModule, abModule, permissionV2Module, documentParseModule, imageUploadModule, generalFileUploadModule, userSettingsModule];
